export class FsaAppointment {
  public PrincipalName: string;
  public PrincipalValabilityStatusCode: string;
  public FsaAppointmentID: number;
  public ARRef: number;
  public PrinRef: number;
  public Status: string;
  public SDate: Date;
  public Changed: Date;
}
